import React from "react";
import "./style.scss";

interface IProps {
  label: string;
  value: string;
  name: string;
  setValue: (value: string) => void;
}

const TextAreaCustom: React.FC<IProps> = ({ label, value, setValue, name }: IProps) => {
  return (
    <div className={"form-text-area"}>
      <label htmlFor={name}>{label}</label>
      <textarea value={value} name={name} rows={6} cols={50} onChange={event => setValue(event.target.value)}>
        {value}
      </textarea>
    </div>
  );
};

export default TextAreaCustom;
